import './App.css';
import {useState} from 'react';
function Menu({context}) {
  const [menuData, setMenuData] = useState(false);
  context.setMenuData = (data)=>{
    setMenuData(data);
  };

  return (
    <div className={"react-map-side-bar "+(menuData === false ? "": "open")}>
      <div className="react-map-side-bar-header">
        <div className="icon arrow" onClick={()=>{setMenuData(false);if(context.closedMenu){ context.closedMenu(); }}}></div>
        <span className="text1">{menuData?.title}</span>
        {menuData?.latitude && menuData?.longitude && <a className="icon directions" href={`https://www.google.com/maps/dir//${menuData?.latitude},${menuData?.longitude}`}> </a>}
      </div>
      <div className="react-map-side-bar-body">
        {menuData?.info && menuData.info.map((entry)=>(
          <div className="react-map-tag">
            <div className="text2">{entry.name}</div>
            <div className="text1">{entry.data}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Menu;
